module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    staticClass: "z-BUlist",
    attrs: {
      "title": 'BU列表'
    }
  }, [_c('div', {
    staticClass: "search-top"
  }, [_c('el-input', {
    staticClass: "top-input",
    attrs: {
      "placeholder": _vm.holdertext
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: (_vm.searchType),
      callback: function($$v) {
        _vm.searchType = $$v
      },
      expression: "searchType"
    }
  }, _vm._l((_vm.searchOptions), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "back-btn shift",
    on: {
      "click": _vm.searchBu
    }
  }, [_vm._v("搜索BU")]), _vm._v(" "), _c('div', {
    staticClass: "back-btn blue",
    on: {
      "click": _vm.newBu
    }
  }, [_vm._v("新建BU")]), _vm._v(" "), _c('div', {
    staticClass: "back-btn red",
    on: {
      "click": function($event) {
        _vm.deleteBu()
      }
    }
  }, [_vm._v("删除BU")])], 1), _vm._v(" "), _c('div', {
    staticClass: "back-list page"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_c('el-checkbox', {
    on: {
      "change": _vm.checkList
    },
    model: {
      value: (_vm.checkall),
      callback: function($$v) {
        _vm.checkall = $$v
      },
      expression: "checkall"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("BU名称")]), _vm._v(" "), _c('div', [_vm._v("BU职责")]), _vm._v(" "), _c('div', [_vm._v("包含人数")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.deleteIds),
      callback: function($$v) {
        _vm.deleteIds = $$v
      },
      expression: "deleteIds"
    }
  }, _vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('div', [_c('el-checkbox', {
      attrs: {
        "disabled": item.type !== 0,
        "label": item.id
      },
      on: {
        "change": _vm.changeCheck
      }
    }, [_vm._v(_vm._s(""))])], 1), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_c('span', {
      staticClass: "link-name",
      on: {
        "click": function($event) {
          _vm.link(item)
        }
      }
    }, [_vm._v(_vm._s(item.bu_name))])]), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_vm._v(_vm._s(_vm._f("placeholder")(item.bu_description)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(((item.num) + "人")))]), _vm._v(" "), _c('div', [(item.type == 0) ? _c('span', {
      staticClass: "red",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteBu(item.id)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()])])
  })), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-3111ba34!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/person/page-bu-list.vue
// module id = 716
// module chunks = 1